/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 *
 * @param {object} props
 * @param {string} [props.size='small']
 * @param {string} [props.className]
 * @param {string} [props.title]
 * @returns
 */
export default function VideoIcon({
  className,
  size = 'small',
  title,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className={className}
      viewBox="0 0 24 24"
      {...rest}
    >
      {title && <title>{title}</title>}
      <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"></path>
      <path d="M9.75 15.02L15.5 11.75 9.75 8.48 9.75 15.02z"></path>
    </svg>
  );
}
